<template>
  <b-card card>
    <b-card-header>Add Complaints Items</b-card-header>
    <b-card-body>
      <div class="table-responsive mb-0" :key="key">
        <b-table
          :key="items.key"
          :items="items"
          :fields="fields"
          responsive="sm"
          :filter="filter"
          :per-page="10"
          :current-page="currentPage"
        >
          <!-- Ordered Quantity -->
          <template v-slot:cell(ordered_qty)="row">
            {{ row.item.quantity }}
          </template>

          <!-- Complaints -->
          <template v-slot:cell(complaints)="row">
            <div
              v-for="(complaint, index) in row.item.complaints"
              :key="index"
              style="display: flex; align-items: center; gap: 10px"
            >
              <!-- Complaint Textarea -->
              <b-form-group label="Complaint">
                <b-textarea v-model="complaint.complaint"></b-textarea>
              </b-form-group>

              <!-- Issue Segment Select -->
              <b-form-group label="Issue Segment">
                <b-select
                  :options="issueSegments"
                  v-model="complaint.issue_segment"
                ></b-select>
              </b-form-group>

              <!-- Complaint Image Upload -->
              <b-form-group label="Complaint Image">
                <div>
                  <b-img
                    v-if="
                      complaint.complaint_image_url &&
                      isImage(complaint.complaint_image_url)
                    "
                    height="60"
                    :src="cdn + '/' + complaint.complaint_image_url"
                  ></b-img>
                  <a
                    v-else
                    :href="
                      complaint.complaint_image_url
                        ? cdn + '/' + complaint.complaint_image_url
                        : ''
                    "
                    target="_blank"
                  >
                    Link of attachment
                  </a>
                  <b-form-file
                    accept="*/*"
                    @change="saveImage($event, complaint)"
                  ></b-form-file>
                </div>
              </b-form-group>

              <!-- Divider -->
              <hr v-if="index < row.item.complaints.length - 1" />
            </div>

            <!-- Add Complaint Button -->
            <b-button
              variant="primary"
              size="sm"
              v-if="row.item.complaints.length < 3"
              @click="addComplaint(row.item)"
            >
              Add Complaint
            </b-button>
          </template>
        </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <!-- Pagination -->
              <b-pagination
                :key="items.key"
                v-model="currentPage"
                :total-rows="items.length"
                :per-page="10"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-card-body>
    <b-card-footer>
      <b-button variant="success" @click="saveComplaints">Save</b-button>
    </b-card-footer>
  </b-card>
</template>

<script>
import axios from "axios";
import { OrdersPath, ImagesPath } from "@/path";
import Swal from "sweetalert2";

export default {
  name: "missing_items",
  props: ["selected_order"],
  data() {
    return {
      items: [],
      currentPage: 1,
      fields: ["title", "ordered_qty", "complaints"],
      filter: "",
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      key: 0,
      cdn: process.env.VUE_APP_AWS_CDN,
      issueSegments: [
        "Food Quantity",
        "Wrong Item",
        "Missing Item",
        "Food Spillage",
        "Packaging",
        "Food Quality",
        "Delay Order",
        "Missing Accomp",
        "Wrong SOP",
        "Foreign Particle",
      ],
    };
  },
  mounted() {
    this.getOrderItems();
  },
  methods: {
    isImage(url) {
      return /\.(jpg|jpeg|png|gif)$/i.test(url);
    },
    async saveImage(e, complaint) {
      try {
        let formData = new FormData();
        formData.append("file", e.target.files[0]);
        formData.append("folder", "order_complaints");
        let res = await axios.post(
          this.baseUrl + ImagesPath.UPLOAD_IMAGE,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res.data.status) {
          complaint.complaint_image_url = res.data.data.file;
          this.key += 1;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getOrderItems() {
      try {
        let res = await axios.get(this.baseUrl + OrdersPath.GET_ORDER_ITEMS, {
          params: {
            order_id: this.selected_order.id,
          },
        });
        if (res.data.status) {
          this.items = res.data.data;
          this.items = this.items.map((i) => {
            let d = i;
            // Normalize complaints to always be an array
            if (Array.isArray(i.complaints)) {
              d.complaints = i.complaints;
            } else if (i.complaints) {
              // Wrap single complaint object in an array
              d.complaints = [i.complaints];
            } else {
              d.complaints = [];
            }
            return d;
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    addComplaint(item) {
      if (item.complaints.length < 3) {
        item.complaints.push({
          complaint: "",
          issue_segment: "",
          complaint_image_url: "",
        });
        this.key += 1;
      }
    },
    async saveComplaints() {
      let complaints = this.items.map((item) => {
        return {
          id: item.id,
          order_id: item.order_id,
          complaints: item.complaints,
        };
      });

      console.log(complaints, "complaints");
      try {
        let res = await axios.post(this.baseUrl + OrdersPath.SAVE_COMPLAINTS, {
          complaints: this.items.map((item) => {
            return {
              id: item.id,
              order_id: item.order_id,
              complaints: item.complaints,
            };
          }),
        });
        if (res.data.status) {
          Swal.fire("Added Complaints of Items", "", "success");
          this.$bvModal.hide("bv-complaints");
          this.$emit("update");
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style>
/* Add any custom styles here if needed */
</style>
